import { clearSession } from "./authenticationClient";
import { isSessionTokenError } from "./auth-error";

const LOGIN_PATH = "/auth/login";

export const handleSessionTokenError = (error: unknown) => {
	if (!isSessionTokenError(error)) {
		return;
	}

	clearSession();

	if (typeof window === "undefined") {
		return;
	}

	if (window.location.pathname === LOGIN_PATH) {
		return;
	}

	const redirectTo = window.location.pathname;
	window.location.replace(`${LOGIN_PATH}?redirectTo=${encodeURIComponent(redirectTo)}`);
};
